<template>
    <div class="home">
        <div class="banner">
            <Carousel :slides="banners"></Carousel>
        </div>

        <div class="module series">
            <ModuleTitle class="page-title" :caption="newestSeries.title | pageTitle" :text="newestSeries.subTitle"></ModuleTitle>
            <Series v-for="(series, index) in newestSeries.series" :key="index" :series="series"></Series>
        </div>

        <div class="module story">
           <Story :story="story"></Story>
        </div>
    </div>
</template>

<script>
    import ModuleTitle from '../components/common/ModuleTitle'
    import Carousel from '../components/common/Carousel'
    import Series from '../components/container/home/Series'
    import Story from '../components/container/home/Story'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'home',
        components: {
            Carousel,
            Series,
            ModuleTitle,
            Story,
        },
        computed: {
            ...mapState('homepage', {
                banners: state => {
                    return state.banners.map((banner, index) => {
                        return {
                            isPic: banner.type === 'pic',
                            isVideo: banner.type === 'video',
                            video: {
                                ref: 'bannerVideo' + index,
                                videoSrc: banner.src_file,
                                loop: true,
                                muted: true,
                                autoplay: true,
                            },
                            tip: banner.note,
                            caption: banner.title,
                            text: banner.content,
                            imgSrc: banner.src_file,
                            btn: {
                                text: banner.btn_text,
                                to: banner.btn_link
                            },
                            width: 1680,
                            height: 800,
                        }
                    })
                },
                newestSeries: state => {
                    let newestSeries = {},tip = {}
                    //newestSeries.title = state.newestSeries.title
                    newestSeries.title = state.newestSeries.description
                    newestSeries.subTitle = state.newestSeries.description

                    const series = state.newestSeries.new_categories.map((series, index) => {
                        const slides = series.banner_pictures.map((img, subIndex) => {
                            tip = {
                                tip: series.note,
                                caption: series.name_in_title,
                                text: series.description,
                                imgSrc: img.src_file,
                                btn: {
                                    text: series.banner_button_text,
                                    to: series.banner_button_href
                                },
                            }
                            return {
                                isPic: img.type === 'pic',
                                isVideo: img.type === 'video',
                                video: {
                                    ref: 'seriesVideo' + index + subIndex,
                                    videoSrc: img.src_file,
                                    loop: true,
                                    muted: true,
                                    autoplay: true,
                                },
                                imgSrc: img.src_file,
                                // tip: series.note,
                                // caption: series.name + '系列',
                                // text: series.description,
                                // imgSrc: img.src_file,
                                // btn: {
                                //     text: series.banner_button_text,
                                //     to: series.banner_button_href
                                // },
                                width: 1680,
                                height: 600,
                            }
                        })

                        const lang = localStorage.getItem('lang') || 'cn'

                        let products = {
                            title: lang === 'cn' ? '精选商品' : 'FEATURED PRODUCTS',
                            redirect: {
                                //text: lang === 'cn' ? '查看全部' : 'VIEW ALL',
                                text: state.newestSeries.view_all_btn_text,
                                to: series.slug,
                            },
                        }
                        const items = series.selected_products.map(product => {
                            return {
                                parentPath: '/product/',
                                tags: product.tags,
                                slug: product.slug,
                                imgSrc: product.cover_picture,
                                title: series.name,
                                label: product.subcategory_name,
                                desc: [
                                    {
                                        text: product.product_name,
                                    },
                                    {
                                        text: product.price,
                                    }
                                ]
                            }
                        })
                        products.items = items


                        return {
                            tip,
                            slides,
                            products,
                        }
                    })

                    newestSeries.series = series

                    return newestSeries
                },

                story: state => {
                    const stories = state.stories.new_stories.map(story => {

                        return {
                            parentPath: '/stories/',
                            slug: story.slug,
                            isOverlay: true,
                            text: story.title,
                            imgSrc: story.cover_pic
                        }
                    })

                    return {
                        title: state.stories.title,
                        subTitle: state.stories.description,
                        btn: {
                            text: state.stories.btn_text,
                            to: '/stories'
                        },
                        stories: stories,
                    }
                }
            })
        },
        methods: {
            ...mapActions('homepage', ['getBanners'])
        },
        created() {
            this.getBanners()
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .banner {
        /deep/ .carousel-item {
            padding-bottom: 47.6% !important;
        }
    }

    .story {
       /deep/ .title {
            padding-bottom: 0;
        }
    }
</style>
